// @flow
import React, { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from '@finect/front-core/Routes';
import { NotFound } from '@finect/tabular-components/NotFound';
import { Datalayer } from '@finect/front-gtm';
import { know } from '../../data';

type Props = {
  toggleModal: Function,
  match: Object
};

export const Know = ({ toggleModal, ...rest }: Props) => (
  <Switch>
    {know.map((route, index) => (
      <Route
        key={index}
        exact={route.exact}
        path={route.path}
        render={(props) => {
          const RouteComponent = route.component;

          return (
            <Fragment>
              <Datalayer id="Scene" type="ready" params={{ pageType: 'advisersArticle', pageId: props.match.url }} />
              <Datalayer id="Scene" type="pageType" params={{ pageType: 'advisersArticle', pageId: props.match.url }} />

              <RouteComponent toggleModal={toggleModal} {...props} />
              {/* {React.createElement(route.component, { toggleModal, ...props })} */}
            </Fragment>
          );
        }}
      />
    ))}
    <Redirect {...rest} exact from="/asesores/saber" to={know[0].path} status={301} withSPA/>
    <Route render={props => <NotFound actionText="Volver a asesores" redirectPath="/asesores" {...props} />} />
  </Switch>
);
